import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_g44w8cvngj: FaireBrandEntity = {
  token: "b_g44w8cvngj",
  type: "brand",
  name: "Kooniez",
  avatarUrl:
    "https://cdn.faire.com/fastly/d69fd7ea66828a0621088751cd87e1a57d401e73505dc75ca2de63421da1b9a5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/746b4d2f8025561c8aa4bc1528cfd90479af2d74c890e4ae31ce76d278f85f02.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d69fd7ea66828a0621088751cd87e1a57d401e73505dc75ca2de63421da1b9a5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/746b4d2f8025561c8aa4bc1528cfd90479af2d74c890e4ae31ce76d278f85f02.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 200,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Kooniez was built on one simple belief: clothes should feel as good as they look.\n\nBefore Kooniez ever had its own name, we spent over 30 years behind the scenes manufacturing clothing for some of the biggest brands in the industry. We learned what works. We learned what lasts. And we saw where most brands cut corners.\n\nSo we decided to build our own.\n\nNot fast fashion. Not trend-chasing pieces that sit in your closet.\n\nWe create clothing that moves with you. Flowy silhouettes. Comfortable fits. Bold colors. Pieces you can dress up or down and actually live in.\n\nFrom our signature pants to our lace jackets, velvet styles, and everyday staples, everything is made in Los Angeles with intention and experience behind it.\n\nKooniez isn’t about trying too hard.\n\nIt’s about putting something on and instantly feeling confident, comfortable, and like yourself.\n\nAfter 30 years in the industry, we know exactly how clothes should fit.\n\nAnd we make them that way.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:56.505Z",
    importedBy: "entity-db-cli",
  },
};
